import { IAddress } from '~/types'
import { displayBigNumber } from '~/utils/display'

export const getTokenDisplayForTransactionName = (
  balance: bigint,
  token: {
    address: IAddress
    decimals: number
    symbol: string
  },
): string => {
  return ` ${displayBigNumber(balance, {
    displayDecimals: 4,
    tokenDecimals: token.decimals,
    minDisplayDecimals: 0,
  })} ${token.symbol}`
}
